import { LoanStatus, TransferringLoanStatus } from '@willow/types-iso';

export const isTransferringLoan = (loanStatus: LoanStatus): boolean => {
  return TransferringLoanStatus.safeParse(loanStatus).success;
};
